<template>
  <div>
    <div class="sports-bg com-news">
      <div class="txtMarquee-left">
        <div class="block">
          <div class="iconfont icon-tongzhi2"></div>
          <p>
            <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.announcement')}}</font></font>
          </p>
          <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
            <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.official')}} </font></font></marquee
            >
          </div>
        </div>
      </div>
    </div>
    <div id="sp-content">
      <div class="wrapper">
        <section id="lobby" class="ng-scope">
          <ul class="game-list">
            <li :game-box="'ty-'+item.platform_name" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :title="item.name">
              <!-- <span style="color:#fff">{{item.name}}--{{item.platform_name}}</span> -->

            </li>
          </ul>
    
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sport',
  data() {
    return {
      gameList: [],
      imgList:{
      sbtest: { img: 'sp-more', hover: '/static/image/sbty_hover.png', title: '/static/image/img_saba_title.png' },
      oap: { img: 'sp-ss', hover: '/static/image/ssty_hover.png', title: '/static/image/img_ss_title.png' },
      cmd: { img: 'sp-cmd', hover: '/static/image/cmd_hover.png', title: '/static/image/img_cmd_title.png' },
      hbb: { img: 'sp-hbb', hover: '/static/image/asia_hover.png', title: '/static/image/img_asia_title.png' },
      saba: { img: 'sp-saba', hover: '/static/image/tg_hover.png', title: '/static/image/img_tgty_title.png' },
      xsbo: { img: 'sp-more', hover: '/static/image/sbo_hover.png', title: '/static/image/img_sbo_title.png' },
      obgty: { img: 'sp-more', hover: '/static/image/ob-hover.png', title: '/static/image/img_obty_title.png' },
      bbin: { img: 'sp-more', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bbinty_title.png' },
      }
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'sport' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.$parent.hideLoading();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/sport.vue